<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>{{ rowId ? '业务与服务编辑' : '业务与服务创建' }}</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/product')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="130px"
        ref="formData"
      >
        <el-form-item label="产品与业务" prop="type">
          <el-radio-group
            v-model="type"
            size="small"
            v-for="(item, index) in menuList"
            :key="index"
          >
            <el-radio
              :disabled="true"
              v-for="(pro, i) in item.subOfficialWebsiteMenus"
              :key="i"
              :label="pro.type"
              border
              >{{ pro.title }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <div class="center">产品介绍</div>
        <el-form-item label="产品名称" prop="title">
          <el-input style="width: 40%" clearable v-model="formData.title">
          </el-input>
        </el-form-item>
        <el-form-item label="产品大图" prop="thumbnail">
          <imageUpload
            v-model="formData.thumbnail"
            :isShowTip="false"
            :limit="1"
          />
        </el-form-item>

        <el-form-item label="内容(段落)" prop="content">
          <MyEditor ref="editor" key="i" v-model="formData.content" />
        </el-form-item>

        <div class="center">产品功能</div>
        <el-form-item label="标题" prop="abilitTitle">
          <el-input style="width: 40%" clearable v-model="formData.abilitTitle">
          </el-input>
        </el-form-item>
        <el-form-item label="功能点" prop="abilityArr">
          <el-row v-if="formData.abilityArr && formData.abilityArr.length > 0">
            <div
              v-for="(file, fileIndex) in formData.abilityArr"
              style="display: flex"
              :key="fileIndex + 'wj'"
            >
              <el-row :gutter="24" style="margin-bottom: 20px">
                <el-col :span="20">
                  <el-form-item
                    style="margin-bottom: 10px"
                    :label="'功能点' + (fileIndex + 1) + '：'"
                    :prop="file.remark"
                  >
                    <el-input
                      clearable
                      v-model="file.remark"
                      maxlength="8"
                      placeholder="请输入功能点"
                    />
                  </el-form-item>
                  <el-form-item label="缩略图:" :prop="file.thumbnail">
                    <imageUpload
                      v-model="file.thumbnail"
                      :isShowTip="false"
                      :limit="1"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="!formData.id">
                  <div style="display: flex">
                    <el-button
                      type="primary"
                      icon="el-icon-delete"
                      size="mini"
                      plain
                      @click="deleteAbilityFn(fileIndex)"
                    ></el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-row>
          <el-button
            v-if="!formData.id"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            plain
            @click="addAbilityFn"
            >新增功能点</el-button
          >
        </el-form-item>
        <div class="center">价值点</div>
        <el-form-item label="标题" prop="valueTitle">
          <el-input style="width: 40%" clearable v-model="formData.valueTitle">
          </el-input>
        </el-form-item>

        <el-form-item label="价值点简介" prop="valueContent">
          <MyEditor ref="editor1" key="k" v-model="formData.valueContent" />
        </el-form-item>
        <el-form-item label="价值点大图" prop="valueImgUrl">
          <imageUpload
            v-model="formData.valueImgUrl"
            :isShowTip="false"
            :limit="1"
          />
        </el-form-item>
        <el-form-item label="价值点" prop="valueArr">
          <el-row v-if="formData.valueArr && formData.valueArr.length > 0">
            <div
              v-for="(file, fileIndex) in formData.valueArr"
              style="display: flex"
              :key="fileIndex + 'wj'"
            >
              <el-row :gutter="24" style="margin-bottom: 20px">
                <el-col :span="20">
                  <el-form-item
                    style="margin-bottom: 10px"
                    :label="'价值点' + (fileIndex + 1) + '：'"
                    :prop="file.remark"
                  >
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      v-model="file.remark"
                      placeholder="请输入价值点"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="!formData.id">
                  <div style="display: flex">
                    <el-button
                      type="primary"
                      icon="el-icon-delete"
                      size="mini"
                      plain
                      @click="deleteValueFn(fileIndex)"
                    ></el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-row>
          <el-button
            v-if="!formData.id"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            plain
            @click="addValueFn"
            >新增价值点</el-button
          >
        </el-form-item>
        <div class="center">技术亮点</div>
        <el-form-item label="标题" prop="techTitle">
          <el-input style="width: 40%" clearable v-model="formData.techTitle">
          </el-input>
        </el-form-item>
        <el-form-item label="技术亮点" prop="techArr">
          <el-row v-if="formData.techArr && formData.techArr.length > 0">
            <div
              v-for="(file, fileIndex) in formData.techArr"
              style="display: flex"
              :key="fileIndex + 'wj'"
            >
              <el-row :gutter="24" style="margin-bottom: 20px">
                <el-col :span="20">
                  <el-form-item
                    style="margin-bottom: 10px"
                    :label="'亮点' + (fileIndex + 1) + '：'"
                    :prop="file.remark"
                  >
                    <el-input
                      v-model="file.remark"
                      placeholder="请输入亮点小标题"
                    />
                  </el-form-item>
                  <el-form-item
                    style="margin-bottom: 10px"
                    label="内容"
                    :prop="file.content"
                  >
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      v-model="file.content"
                      placeholder="请输入亮点内容"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="!formData.id">
                  <div style="display: flex">
                    <el-button
                      type="primary"
                      icon="el-icon-delete"
                      size="mini"
                      plain
                      @click="deleteTechFn(fileIndex)"
                    ></el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-row>
          <el-button
            v-if="!formData.id && this.formData.techArr.length < 4"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            plain
            @click="addTechFn"
            >新增技术亮点</el-button
          >
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center; padding-top: 20px"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>保存</span>
          </el-button>
          <!-- <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="reset"
          >
            <span>重置</span>
          </el-button> -->
        </div>
      </el-form>
      <!-- <tz-form
        width="130px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
        @cleanFn="resultClean"
      ></tz-form> -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
//
import { productMenus, productList, productAdd } from '@/api/product'
import { uploadFile } from '@/api/advertising'
import MyEditor from './components/MyEditor.vue'
// import { info } from 'sass'
export default {
  components: { MyEditor },

  data() {
    return {
      resultSelect: true,
      formData: { type: '', abilityArr: [], valueArr: [], techArr: [] },
      type: '', //1:检测检查 2:机管家 3:塔司管理 4:吊钩可视化 5:主动安全防碰撞 6:基于AI的无人机巡检系统
      menuId: '',
      menuList: [],
      itemList: [],
      photoList: [],
      // valueContent: '', //价值点内容
      valueImgUrl: [], //价值点大图
      rowId: null,
      rules: {
        title: [
          { required: true, message: '名称必填', trigger: ['blur', 'change'] }
        ],
        // type: [
        //   { required: true, message: '类型必填', trigger: ['blur', 'change'] }
        // ],
        thumbnail: [
          { required: true, message: '图片必传', trigger: ['blur', 'change'] }
        ],
        content: [
          { required: true, message: '内容必填', trigger: ['blur', 'change'] }
        ],
        valueImgUrl: [
          { required: true, message: '图片必传', trigger: ['blur', 'change'] }
        ],
        // valueContent: [{ required: true, message: '内容必填', trigger: 'blur' }],
        abilityArr: [
          { required: true, message: '功能点必填', trigger: ['blur', 'change'] }
        ],
        valueArr: [
          { required: true, message: '价值点必填', trigger: ['blur', 'change'] }
        ]
        // techArr: []
      }
    }
  },

  mounted() {
    this.type = Number(this.$route.query.type)
    this.menuId = Number(this.$route.query.id)
    // this.formData.type = this.type
    // console.log(this.type, '类型')

    this.getInfo()
    this.getMenus()
  },
  methods: {
    getMenus() {
      productMenus().then((res) => {
        // console.log(res, '菜单')
        if (res.code == 200) {
          res.data.find((item) => {
            if (item.id == '3') {
              this.menuList = item.subOfficialWebsiteMenus
            }
          })
          console.log(this.menuList, '菜单列表1')
          this.$forceUpdate()
        }
      })
    },
    // 查看详情
    getInfo() {
      productList({ type: this.type }).then((response) => {
        if (response.data.records && response.data.records.length > 0) {
          //有数据变成修改
          this.reset()
          // this.type = this.type
          console.log(response.data.records, '详情')
          this.rowId = 1
          let that = this
          that.reset()
          let infos = response.data.records
          if (infos && infos.length > 0) {
            infos.forEach(function (item) {
              if (item.kind == 1) {
                that.formData.title = item.title
                that.formData.content = item.content
                that.$refs.editor.html = item.content

                that.formData.thumbnail = item.thumbnail
              }
              if (item.kind == 2) {
                that.formData.abilitTitle = item.title
                that.formData.abilityArr.push(item)
              }
              if (item.kind == 3) {
                that.formData.valueArr.push(item)
                that.formData.valueImgUrl = item.thumbnail
                that.formData.valueContent = item.content
                that.$refs.editor1.html = item.content
                that.$set(that.formData, 'valueContent', item.content)
                that.formData.valueTitle = item.title
                // that.valueImgUrl = item.thumbnail
                // that.valueContent = item.content
                console.log(that.formData.valueContent, '价值点')
              }
              if (item.kind == 4) {
                that.formData.techTitle = item.title
                that.formData.techArr.push(item)
              }
            })
          }

          this.$forceUpdate()
        }
      })
    },
    // 新增功能点
    addAbilityFn() {
      this.formData.abilityArr.push({
        title: null,
        remark: null,
        thumbnail: null,
        kind: 2
      })
      // console.log(this.formData.abilityArr, '新增功能点')

      this.$forceUpdate()
    },
    // 新增价值点
    addValueFn() {
      this.formData.valueArr.push({
        title: null,
        content: null,
        remark: null,
        kind: 3
      })

      this.$forceUpdate()
    },
    // 新增技术亮点
    addTechFn() {
      this.formData.techArr.push({
        title: null,
        remark: null,
        content: null,
        kind: 4
      })

      this.$forceUpdate()
    },
    //删除简介段落
    // deleteDescFn(item) {
    //   this.formData.productDesc.splice(item, 1)
    // },
    //删除功能点
    deleteAbilityFn(item) {
      this.formData.abilityArr.splice(item, 1)
    },
    //删除价值点
    deleteValueFn(item) {
      this.formData.valueArr.splice(item, 1)
    },
    //删除技术亮点
    deleteTechFn(item) {
      this.formData.techArr.splice(item, 1)
    },

    // 监听radio框变化
    handleClick(val) {
      this.formData.resultValue = ''
      console.log(val)
      if (val === 1) {
        this.resultSelect = true
      } else if (val === 2) {
        this.resultSelect = false
      }
    },
    // 重置
    // clearFn() {
    //   this.resultSelect = true
    //   this.$refs['formData'].resetFields()
    // },
    // 表单重置
    reset() {
      this.formData = {
        // productDesc: [],
        abilityArr: [],
        valueArr: [],
        techArr: [],
        valueImgUrl: [],
        id: null,
        title: null,
        abilitTitle: null,
        valueTitle: null,
        techTitle: null,
        content: null,
        valueContent: null,
        thumbnail: null
        // type: null //  //1:检测检测 2:机管家 3:塔司机管理 4:吊钩可视化 5:主动安全防碰撞 6:基于AI的无人机巡检系统

        // pushMp: 2, //推送公众号
        // pushMpFlag: 2, //公众号是否启用
        // pushOfficialWebsite: 1, //是否推官网
        // pushOfficialWebsiteFlag: 1 //官网是否启用
      }
      this.$refs['formData'].resetFields()
      this.$refs['editor'].html = ''
      this.$refs['editor1'].html = ''
      // this.formData.type = this.type
      console.log(this.formData, '重置')
      this.$forceUpdate()
    },
    // 上传照片
    photoUpload() {
      this.formData.thumbnail = ''
      const formData = new FormData()
      this.photoList.forEach((el) => {
        console.log(el)
        formData.append('multipartFile', el.raw)
      })
      this.$loading({
        text: '图片上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.thumbnail = res.data.uploadUrl
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.formData.thumbnail = ''
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.photoList = []
          this.$loading().close()
        }
      })
    },

    //移除头像
    photoRemove(file, fileList) {
      this.photoList = fileList
      this.formData.thumbnail = ''
    },

    // 照片类型限制
    checkFileType(file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg') {
        // 不处理
        console.log('格式正确')
      } else {
        this.$message.error('不是.jpeg,.png,.jpg文件,请上传正确的图片类型')
        return false
      }
    },

    //头像超限制
    photoExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.error(`只允许一次性上传1张图片`)
    },
    photoChange(file, fileList) {
      // console.log(this.fileList, 'change')

      this.photoList = fileList
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.photoList = []
        return
      }
      this.photoList = fileList
    },

    // 提交
    submitFn() {
      // console.log(this.$refs.editor.html, '创建')
      this.formData.content = this.$refs.editor.html
      this.formData.valueContent = this.$refs.editor1.html
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          // this.$loading({
          //   text: '报告添加中'
          // })
          console.log(this.formData, '提交')
          const newFormat = [
            {
              title: this.formData.title,
              kind: 1,
              thumbnail: this.formData.thumbnail,
              type: this.type,
              content: this.formData.content,
              menuId: this.menuId
            },
            ...this.formData.abilityArr.map((item) => ({
              menuId: this.menuId,
              type: this.type,
              kind: item.kind,
              title: this.formData.abilitTitle,
              thumbnail: item.thumbnail,
              remark: item.remark,
              content: item.content
            })),
            ...this.formData.valueArr.map((item) => ({
              menuId: this.menuId,
              type: this.type,
              kind: item.kind,
              title: this.formData.valueTitle,
              thumbnail: this.formData.valueImgUrl,
              content: this.formData.valueContent,
              remark: item.remark
            })),
            ...this.formData.techArr.map((item) => ({
              menuId: this.menuId,
              type: this.type,
              kind: item.kind,
              title: this.formData.techTitle,
              content: item.content,
              remark: item.remark
            }))
          ]
          console.log(newFormat, '修改格式提交')
          if (this.rowId == null) {
            productAdd(newFormat).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          } else {
            productAdd(newFormat).then((res) => {
              console.log(res.data, '修改')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          }
        } else {
          this.$message({
            message: '请输入必填项',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
.center {
  border-bottom: 1px solid rgb(232, 232, 232);
  margin: 20px 0;
  padding-bottom: 20px;
  padding-top: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
